import { PlusIcon } from "lucide-react";
import { useCallback } from "react";

import { useCommandPaletteStore } from "../../commandPaletteStore";
import { Button } from "../ui/button";
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from "../ui/empty";
import { SidebarInset } from "../ui/sidebar";

/**
 * The no-projects workspace state, ported from upstream's
 * `components/NoProjectsHero.tsx` (parity pin `e3e7cc3f`). It backs the
 * welcome wizard at `/welcome`. The add-project CTA opens the command
 * palette's project-import flow, forge's equivalent of upstream's
 * add-project palette intent.
 */
export function NoProjectsHero() {
  const openAddProject = useCallback(
    () => useCommandPaletteStore.getState().openAddProjectSources(),
    [],
  );

  return (
    <SidebarInset className="h-dvh min-h-0 overflow-hidden overscroll-y-none">
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-x-hidden bg-background">
        <Empty className="flex-1">
          <div className="w-full max-w-lg px-8 py-12">
            <EmptyHeader className="max-w-none">
              <EmptyTitle>What should we work on?</EmptyTitle>
              <EmptyDescription>Add a project to start your first thread.</EmptyDescription>
              <div className="mt-6 flex justify-center">
                <Button size="sm" onClick={openAddProject}>
                  <PlusIcon className="size-4" />
                  Add project
                </Button>
              </div>
            </EmptyHeader>
          </div>
        </Empty>
      </div>
    </SidebarInset>
  );
}
